import question_alert_icon from './question_alert_icon.svg';
import question_tick_icon from './question_tick_icon.svg';
import question_blue_icon from './question_blue_icon.svg';
import question_icon from './question_icon.svg';


export default {question_alert_icon, question_tick_icon, question_icon, question_blue_icon};
